/* shark proxy telemetry */

export enum ETelemetryGroupBy {
  TENAT = 'GROUP_BY_TENANT',
  API_KEY = 'GROUP_BY_API_KEY',
  PROTOCOL = 'GROUP_BY_PROTOCOL',
  BLOCKCHAIN = 'GROUP_BY_BLOCKCHAIN',
  METHOD = 'GROUP_BY_METHOD',
}

export enum ETelemetryTopOf {
  IP = 'TOP_OF_IP',
  ERROR = 'TOP_OF_ERROR',
  COUNTRY = 'TOP_OF_COUNTRY',
  METHOD = 'TOP_OF_METHOD',
  BLOCKCHAIN = 'TOP_OF_BLOCKCHAIN',
  PROTOCOL = 'TOP_OF_PROTOCOL',
  API_KEY = 'TOP_OF_API_KEY_MASK',
  MONTHLY_USAGE = 'TOP_OF_MONTHLY_USAGE',
}

export interface IUsageTopElement {
  name: string;
  count: number | string;
}

export interface IUsageTop {
  top_of: ETelemetryTopOf;
  elements: IUsageTopElement[] | null;
}

export interface IUsageDataMRPCRequestBodyParams {
  start: string; // RFC 3339 timestamp
  end: string; // RFC 3339 timestamp
  interval: string; // Interval in seconds between data points, e.g., "86400s" for 1 day
  api_key_values?: string[]; // List of user tokens to filter the data by
  blockchains?: string[]; // List of blockchains in MRPC format to include in the query
  group_by?: ETelemetryGroupBy; // Specifies how to group the results
  top_limit?: number; // Number of top items to return, default is 10
  include_top_ofs?: ETelemetryTopOf[]; // Specific metrics to include in the results
}

export interface IUsageDataMRPCRequestQueryParams {
  unfiltered?: boolean; // If true, the results will not be filtered by the user token
}

export interface IUsageDataMRPCRequestParams
  extends IUsageDataMRPCRequestBodyParams,
    IUsageDataMRPCRequestQueryParams {}

export interface RequestTimelinePoint {
  time: string; // RFC 3339 timestamp ("1710460800")
  value: number; // Value at the given time ("22282")
}

interface RequestTimeline {
  name: string; // Name of the user token
  points: RequestTimelinePoint[]; // List of data points
}

export interface IUsageDataMRPCResponse {
  total: number | string; // Total number of requests
  all_time_total: string | number; // All-time total number of requests
  request_timelines: RequestTimeline[]; // List of request timelines
  tops: IUsageTop[]; // List of top metrics
}
